module.exports = __webpack_public_path__ + "22b8ac43234279f29f90e2f010e38a74.ico";


//////////////////
// WEBPACK FOOTER
// ./src/static/favicon_notification.ico
// module id = 590
// module chunks = 7